import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactLoading from 'react-loading';
import MessageCom from "layouts/Dashboard/Message";
import { musicDirectorActions } from 'redux/actions/music-director-action';
import loginImage from "assets/img/user_login.png";
import forgetImage from "assets/img/Forgot-Password.png";

import 'react-confirm-alert/src/react-confirm-alert.css';
import {

  Button
} from "react-bootstrap";
var Modal = require('react-bootstrap-modal');


class commentGalleryPage extends Component{
  constructor(props){
    super(props);
    this.props.dispatch(musicDirectorActions.logout());
    this.state = {
      username        : '',
      forgetEmail     : '',
      submitted       : false,
      submittedFU     : false,
      forgetEmailModal: false,
    };
    this.handleChange   = this.handleChange.bind(this);
    this.handleSubmit   = this.handleSubmit.bind(this);
    this.forgetEmail = this.forgetEmail.bind(this);
    this.closeModalForgetEmail = this.closeModalForgetEmail.bind(this);
    this.handleSubmitFU = this.handleSubmitFU.bind(this);
  };
  closeModalForgetEmail(){
    this.clearField();
    this.setState({forgetEmailModal:false});
  }
  clearField(){
    this.setState({forgetEmail:''});
  }
  forgetEmail(){
    console.log('hahaha');
    this.clearField();
    this.setState({forgetEmailModal:true});
  }

  handleSubmitFU(e){
    e.preventDefault();

    this.setState({ submitted: true });
    const { forgetEmail } = this.state;
    const { dispatch } = this.props;

    if (forgetEmail) {
      dispatch(musicDirectorActions.forgetUsername(forgetEmail));
    }
  }
  
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });
    const { username } = this.state;
    const { dispatch } = this.props;

    if (username) {
      dispatch(musicDirectorActions.login(username));
    }
  }
  render(){
    const { username, submitted } = this.state;
    const { loading } = this.props;
    return(
      <section className="first_section login_sec not_home grey">
        <div className="section_title">
          <h2>Login</h2>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <img src={loginImage} alt="User login" className="login_icon" />

              <p className="login_text">
                Login to hear the adjudicator’s comments from the festival you attended. Ask your festival company for your login code if you do not have it.You will also be able to upload any recordings or videos of your performance.</p>
              <p className="using_email"> Login using the username on your account </p>
              <form name="form" onSubmit={this.handleSubmit}>
                <div className={(submitted && !username ? ' has-error' : '')}>
                  <input className="recover_email" placeholder="Ex: Username" name="username" value={username} onChange={this.handleChange}  />
                  {submitted && !username &&
                      <div className="help-block">Username is required.</div>
                  }
                </div>

                <div>
                  <button className="recover_btn">Login</button>
                </div>
                <p className="using_email"> <a onClick={this.forgetEmail} style={{color: 'inherit',cursor:'pointer',textDecoration: 'none',fontWeight: '300'}}>Lost your username?</a> </p>
              </form>
            </div>
          </div>
          {
            !this.state.forgetEmailModal &&
            <div className="col-md-6 col-md-offset-3" style={{marginTop: '20px'}}>
              <MessageCom />
            </div>
          }
        </div>

        <Modal show={this.state.forgetEmailModal} onHide={this.closeModalForgetEmail} aria-labelledby="ModalHeader" className="forgetModal">
          <Modal.Body>
            <div className="row">
              <div className="col-md-10 col-md-offset-1 text-center forget_text">
                <img src={forgetImage} alt="" />

                <p>
                  Forgot Password
                </p>
              </div>

              <div className="col-md-12">
                <form onSubmit={this.handleSubmitFU}>
                  <div className="row">
                    <div className="col-md-10 col-md-offset-1">
                      <div className='form-group'>
                        <input type="email" placeholder="Email" name="forgetEmail" className="form-control" onChange={this.handleChange} required/>
                      </div>
                    </div>
                  </div>
                  <div className="row">

                    <div className="col-md-10 col-md-offset-1 text-center">

                      <div className='btn-toolbar'  style={{display:'inline-block'}}>
                        {
                          !loading &&
                          <Button type='submit' bsSize="large" bsStyle="info" style={{marginRight:'10px'}} className="custom_btn forgetBlue" >Send</Button>
                        }
                        { loading &&
                          <ReactLoading type="bars" color="#1DC7EA" height={5} width={40} className="reactLoaderFrontEnd" />  
                        }
                        {
                          !loading &&
                          <Button bsSize="large" bsStyle="warning" onClick={()=>this.closeModalForgetEmail() } className="custom_btn forgetOrange" >Cancel</Button>
                        }
                      </div>
                    </div>

                    <div className="col-md-8 col-md-offset-2 text-center">
                      <p>Lost your username? Enter your email address here and we will send it to you now</p>
                    </div>
                  </div>
                  {
                    this.state.forgetEmailModal &&
                    <div className="row">
                      <div className="col-md-12">
                        <div className="messageModal">
                          <MessageCom />
                        </div>
                      </div>
                    </div>
                  }
                </form>
              </div>
            </div>
          </Modal.Body>
        </Modal>

      </section>
    );
  }
}

function mapStateToProps(state) {
    const { loading, musicDirector, loggedIn } = state.musicDirectorReducer;
    return {
      loading, musicDirector, loggedIn
    };
}

const commentGallery = connect(mapStateToProps)(commentGalleryPage);
export default commentGallery;


// WEBPACK FOOTER //
// ./src/components/FrontEnd/commentGallery.jsx